import React, { useEffect, useState, useRef } from 'react';
import Marquee from "react-fast-marquee";
import { Container, Col, Row, Button, Badge, Card } from 'react-bootstrap';
// import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaArrowRight } from "react-icons/fa";
// import { FaArrowLeft, FaQuoteLeft } from "react-icons/fa";
import '../styles/home.css';
import { useLocation } from "react-router-dom";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-cards';
import { EffectCards } from 'swiper/modules';
import { Link } from 'react-router-dom';

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// import logo1 from '../image/favicon bl.png';

const images = {
  bg1: require('../image/slide1.jpg'),
  bg1c: require('../image/slidec1.jpg'),
  bg1d: require('../image/slided1.jpg'),
  cheff: require('../image/cheff.jpg'),
  v1: require('../image/fvector.png'),
  demo: require('../image/demo.jpg'),
  vh1: require('../image/vh1.avif'),
  vh2: require('../image/vh2.jpg'),
  pdf: require('../image/download.png'),
};
const works = {
  w1: require('../work/1.jpg'),
  w2: require('../work/2.jpg'),
  w3: require('../work/3.jpg'),
  w4: require('../work/4.jpg'),
  w5: require('../work/5.jpg'),
  w6: require('../work/6.jpg'),
  w7: require('../work/7.jpg'),
  w8: require('../work/8.jpg'),
  w9: require('../work/9.jpg'),
  w10: require('../work/10.jpg'),
  w11: require('../work/11.jpg'),
  w12: require('../work/12.jpg'),
  w13: require('../work/13.jpg'),
  w14: require('../work/14.jpg'),
  w15: require('../work/15.jpg'),
  w16: require('../work/16.jpg'),
};
const companies = {
  agiri: require('../company/agiri.webp'),
  anjali: require('../company/anjali.png'),
  bluestar: require('../company/bluestar.png'),
  bluestone: require('../company/bluestone.webp'),
  davariya: require('../company/davariya.png'),
  dharma: require('../company/dharma.png'),
  dm: require('../company/dm.avif'),
  greenlab: require('../company/greenlab.webp'),
  gurukrupa: require('../company/gurukrupa.webp'),
  kg: require('../company/kg.png'),
  kgk: require('../company/kgk.png'),
  mani: require('../company/mani.png'),
  neon: require('../company/neon.webp'),
  sheetal: require('../company/sheetal.png'),
  sparkle: require('../company/sparkleimpex.png'),
  svgroup: require('../company/svgroup.png'),
  venus: require('../company/venus.png'),
  zest: require('../company/zest.png'),
};


const slides = [
  { img: works.w1, caption: "This is 1" },
  { img: works.w2, caption: "This is 2" },
  { img: works.w3, caption: "This is Caption 3" },
  { img: works.w4, caption: "This is Caption 4" },
  { img: works.w5, caption: "This is Caption 5" },
  { img: works.w6, caption: "This is Caption 6" },
  { img: works.w7, caption: "This is Caption 7" },
  { img: works.w8, caption: "This is Caption 8" },
  { img: works.w9, caption: "This is Caption 9" },
  { img: works.w10, caption: "This is Caption 10" },
  { img: works.w11, caption: "This is Caption 11" },
  { img: works.w12, caption: "This is Caption 12" },
  { img: works.w13, caption: "This is Caption 13" },
  { img: works.w14, caption: "This is Caption 14" },
  { img: works.w15, caption: "This is Caption 15" },
  { img: works.w16, caption: "This is Caption 16" },
];




const { agiri, anjali, bluestar, bluestone, davariya, dharma, dm, greenlab, gurukrupa, kg, kgk, mani, neon, sheetal, sparkle, svgroup, venus, zest } = companies;
const logos = [agiri, anjali, bluestar, bluestone, davariya, dharma, dm, greenlab, gurukrupa];
const logos2 = [kg, kgk, mani, neon, sheetal, sparkle, svgroup, venus, zest];


gsap.registerPlugin(ScrollTrigger);


const statsData = [
  { number: "50+", text: "Clients" },
  { number: "54k+", text: "Delevered" },
  { number: "8+", text: "Retention" },
  // { number: "60%", text: "Diamond & jewelry" },
];


const Home = () => {

  const sectionRef = useRef(null);
  const sectionminaboutRef = useRef(null);
  const ImageRef = useRef(null);
  const titleRef = useRef(null);
  const subTitleRef = useRef(null);
  const btnRef = useRef(null);
  const miniaboutbtnRef = useRef(null);
  const miniabouttitleRef = useRef(null);
  const statsRef = useRef(null);
  const cardimg1Ref = useRef(null);
  const cardimg2Ref = useRef(null);
  const card1Ref = useRef(null);
  const card2Ref = useRef(null);
  const quateRef = useRef(null);
  const qoutebtnRef = useRef(null);
  const qoutetitleRef = useRef(null);

  const downloadPDF = () => {
    const link = document.createElement("a");
    link.href = process.env.PUBLIC_URL + "/ChamundaTailor.pdf";
    link.download = "Chamunda-Tailor-Profile.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  // banner data animation
  useEffect(() => {
    gsap.fromTo(
      titleRef.current, { y: -80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      }
    );
    gsap.fromTo(
      subTitleRef.current, { x: -80, opacity: 0 },
      {
        x: 0,
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      }
    );
    gsap.fromTo(
      btnRef.current, { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionRef.current,
          start: "top 80%",
        },
      }
    );

  });

  // banner img animation
  useEffect(() => {
    if (!ImageRef.current) return;

    const animation = gsap.fromTo(
      ImageRef.current,
      { scale: 0.65 },
      {
        scale: 1.25,
        scrollTrigger: {
          trigger: ImageRef.current,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      }
    );

    return () => {
      animation.scrollTrigger?.kill();
      animation.kill();
    };
  }, []);


  // const [count2, setCount2] = useState(0);
  // const [count3, setCount3] = useState(0);




  // counter animation
  useEffect(() => {
    const ctx = gsap.context(() => {
      const numbers = gsap.utils.toArray(".stat-circle .number");
      const texts = gsap.utils.toArray(".stat-text");

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: statsRef.current,
          start: "top 85%",
        },
      });

      numbers.forEach((num, i) => {
        tl.fromTo(
          num.parentElement,
          { scale: 0, opacity: 0 },
          { scale: 1, opacity: 1, duration: 0.6, ease: "power3.out" },
          i * 0.2
        )
          .fromTo(
            texts[i],
            { opacity: 0, y: 20 },
            { opacity: 1, y: 0, duration: 0.5, ease: "power3.out" },
            i * 0.2 + 0.1
          )
          .to(num, {
            innerText: parseInt(statsData[i].number), // numeric part only
            duration: 2,
            ease: "power1.out",
            snap: { innerText: 1 }
          }, i * 0.2);
      });
    }, statsRef);

    return () => ctx.revert();
  }, []);



  const [bgImage, setBgImage] = useState(images.bg1);

  useEffect(() => {
    const updateImage = () => {
      if (window.innerWidth <= 530) {
        setBgImage(images.bg1d);
      } else if (window.innerWidth <= 768) {
        setBgImage(images.bg1c);
      } else {
        setBgImage(images.bg1);
      }
    };

    // Run immediately once when the component mounts
    updateImage();

    // Then listen for resize events
    window.addEventListener("resize", updateImage);
    return () => window.removeEventListener("resize", updateImage);
  }, []);


  // miniabout animation
  useEffect(() => {
    if (!miniabouttitleRef.current || !miniaboutbtnRef.current) return;
    gsap.fromTo(
      miniaboutbtnRef.current, { y: 80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionminaboutRef.current,
          start: "top 80%",
        },
      }
    );

    gsap.fromTo(
      miniabouttitleRef.current, { y: -80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: sectionminaboutRef.current,
          start: "top 80%",
        },
      }
    );

  }, []);

  // card img zoom
  useEffect(() => {
    if (!cardimg1Ref.current || !cardimg2Ref.current) return;

    gsap.fromTo(cardimg1Ref.current, { scale: 1 }, {
      scale: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: card1Ref.current,
        start: "top 80%",
        end: "bottom top",
        scrub: true,
      },
    });

    gsap.fromTo(cardimg2Ref.current, { scale: 1 }, {
      scale: 1.2,
      ease: "power3.out",
      scrollTrigger: {
        trigger: card2Ref.current,
        start: "top 80%",
        end: "bottom top",
        scrub: true,
      },
    });
  }, []);

  // quate animation
  useEffect(() => {
    if (!qoutebtnRef.current || !qoutetitleRef.current) return;
    gsap.fromTo(
      qoutebtnRef.current, { y: 40, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.4,
        ease: "power3.out",
        scrollTrigger: {
          trigger: quateRef.current,
          start: "top 80%",
        },
      }
    );

    gsap.fromTo(
      qoutetitleRef.current, { y: -80, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.5,
        ease: "power3.out",
        scrollTrigger: {
          trigger: quateRef.current,
          start: "top 80%",
        },
      }
    );

  }, []);


  const { pathname } = useLocation();

  // scroll behaviour
  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    });
  }, [pathname]);




  return (
    <>
      {/* ========== 1 : slider ========== */}
      <section id="home" className="hero_slider hero_sliderhomepage" ref={sectionRef}>
        <div className='imgdiv'>
          <img
            ref={ImageRef}
            src={bgImage.default || bgImage}
            className="d-block w-100 imgdivimg"
            alt="img-1"
            style={{
              height: '100%',
              boxShadow: 'rgba(0, 0, 0, 7) 0px -50px 36px -28px inset',
              maskImage:
                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",
              WebkitMaskImage:
                "linear-gradient(to bottom, transparent 0%, rgba(0,0,0,1) 10%, rgba(0,0,0,1) 85%, transparent 100%)",

            }}
          />
          <div className="carousel-caption col-md-6 col-10 col-offset-md-6">
            <h2 className='linehh' ref={titleRef}>Trusted by India's top companies</h2>
            <h1 style={{ fontSize: '5.5rem' }} ref={subTitleRef}>Uniform <span>Experts</span></h1>
            <a
              href="/ChamundaTailor.pdf"
              download="Chamunda-Tailor-Profile.pdf"
              style={{ textDecoration: "none" }}
            >
              <button
                className="mainbtn main-btn22 btn-primary btn-ghost btn-multiple-border-stroke"
                ref={btnRef}
                onClick={downloadPDF}
              >
                <div className="btn-borders-group">
                  <div className="border-top btn-bboo"></div>
                  <div className="border-right btn-bboo"></div>
                  <div className="border-bottom btn-bboo"></div>
                  <div className="border-left btn-bboo"></div>
                </div>

                <div className="btn-borders-group">
                  <div className="border-top btn-bboo"></div>
                  <div className="border-right btn-bboo"></div>
                  <div className="border-bottom btn-bboo"></div>
                  <div className="border-left btn-bboo"></div>
                </div>

                <div className="btn-borders-group">
                  <div className="border-top btn-bboo"></div>
                  <div className="border-right btn-bboo"></div>
                  <div className="border-bottom btn-bboo"></div>
                  <div className="border-left btn-bboo"></div>
                </div>

                <span className="btn-text">
                  PDF
                  <img src={images.pdf} alt="Download" className="pdfdownload" />
                </span>
              </button>
            </a>
          </div>
        </div>

      </section>
      <br /><br /><br />
      {/* 4 Circle Stats (Floating Bottom) */}
      <Container className="stats-container" ref={statsRef}>
        {statsData.map((item, index) => {
          // Split number and suffix (e.g., 54k+ → number: 54, suffix: k+)
          const match = item.number.match(/^(\d+)(.*)$/);
          const suffix = match ? match[2] : "";

          return (
            <div className="stat-item" key={index}>
              <div className="stat-circle">
                <span className="number">0</span>
                <span className="suffix">{suffix}</span>
              </div>
              <p className="stat-text">{item.text}</p>
            </div>
          );
        })}
      </Container>

      <br /><br />

      {/* ========== 2 : About Us Section ========== */}
      <section id="minabout" ref={sectionminaboutRef}>
        <div className="minabout-section wrapper">
          <Container>
            <div className="row align-items-center">
              {/* Image Section */}
              <div className="col-lg-5 col-md-5 mb-lg-0 mb-5 about-slider">
                <img src={images.v1} className="d-block w-100" alt="..." />
              </div>

              {/* Text Section */}
              <div className="minabout-txt col-lg-7 col-md-7 text-sec position-relative px-lg-5">
                <div className="rectangle-shape small"></div>
                <div className="circle-shape large"></div>
                <h2 ref={miniabouttitleRef}>Crafting Excellence in Corporate Attire</h2>
                <p>
                  We specialize in creating high-quality, custom-tailored clothing for corporate clients. With a focus on professionalism and comfort, our garments are designed to enhance your team’s image and boost their confidence. We understand that every detail matters, from the fabric selection to the perfect fit, ensuring your employees look sharp and feel great.
                </p>
                <p>
                  Our skilled artisans bring years of experience to every piece we create, ensuring impeccable craftsmanship and attention to detail. Whether you need uniforms for a large workforce or tailored suits for executives, Chamunda Tailor is committed to meeting your needs with precision and style.
                </p>

                <button class="mainbtn btn-primary btn-ghost btn-multiple-border-stroke" ref={miniaboutbtnRef}>
                  <div class="btn-borders-group">
                    <div class="border-top"></div>
                    <div class="border-right"></div>
                    <div class="border-bottom"></div>
                    <div class="border-left"></div>
                  </div>
                  <div class="btn-borders-group">
                    <div class="border-top"></div>
                    <div class="border-right"></div>
                    <div class="border-bottom"></div>
                    <div class="border-left"></div>
                  </div>
                  <div class="btn-borders-group">
                    <div class="border-top"></div>
                    <div class="border-right"></div>
                    <div class="border-bottom"></div>
                    <div class="border-left"></div>
                  </div>
                  <span class="btn-text">Know More</span>
                </button>

              </div>
            </div>
          </Container>
        </div>
      </section>

      <br /><br /><br />

      <section className="swippp" style={{ overflow: "hidden" }}>
        <Swiper
          effect={"cards"}
          grabCursor={true}
          modules={[EffectCards]}
          className="mySwiper"
        >
          {slides.map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="slide-content">
                <img src={slide.img} alt={`g-img-${index}`} loading="eager"
                  draggable={false} />
                {slide.caption && (
                  <div className="caption swipe-caption">{slide.caption}</div>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </section>

      <br /><br /><br />

      <div className="bigco pt-5 pb-5">

        <div className="marquee-wrapper" style={{ overflow: "hidden" }}>
          <Marquee speed={50} gradient={false} loop={0}>
            {logos.map((logo, index) => (
              <div
                key={index}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 10px",
                  flexShrink: 0,       // important: prevent shrinking
                }}
                className='logo-slide-content'
              >
                <img
                  src={logo}
                  alt={`company-logo-${index}`}
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    display: "block",   // removes extra inline space
                  }}
                  className='slide-logo-iimg'
                />
              </div>
            ))}
          </Marquee>
        </div>

        <div className="p-background" style={{ margin: '5% 0' }}>
          <div className="paralaxx p-0">
            {/* <h2 style={{color: 'white'}}>Chosen by the finest</h2> */}
          </div>
        </div>

        <div className="marquee-wrapper" style={{ overflow: "hidden" }}>
          <Marquee speed={50} gradient={false} loop={0}>
            {logos2.map((logo, index) => (
              <div
                key={index}
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 10px",
                  flexShrink: 0,       // important: prevent shrinking
                }}
                className='logo-slide-content'
              >
                <img
                  src={logo}
                  alt={`company-logo-${index}`}
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "contain",
                    display: "block",   // removes extra inline space
                  }}
                  className='slide-logo-iimg'
                />
              </div>
            ))}
          </Marquee>
        </div>

      </div>

      <br /><br /><br />

      {/* ========== 6 : Gallary ========== */}
      <Container className="my-5">
        <Row>
          {/* Card 1 */}
          <Col xs={12} md={6} className="mb-4" ref={card1Ref}>
            <Card
              className="text-white"
              style={{
                height: "60vh",
                border: "none",
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                cursor: "pointer",
              }}
            >
              {/* Image */}
              <img
                ref={cardimg1Ref}
                src={images.vh1}
                alt="Formal Wear"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 1,
                }}
              />

              {/* Content */}
              <Card.Body
                style={{
                  position: "relative",
                  zIndex: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                  borderRadius: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px -50px 36px 50px inset",
                }}
              >
                <Badge
                  style={{
                    backgroundColor: "rgba(128, 0, 128, 0.7)",
                    width: "fit-content",
                    padding: "2%",
                  }}
                  className="mb-2"
                >
                  FORMAL WEAR
                </Badge>
                <Card.Title
                  style={{ fontWeight: 700, fontSize: "1.5rem", color: "white" }}
                >
                  Premium Formal <br /> Pants & Shirts
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>

          {/* Card 2 */}
          <Col xs={12} md={6} className="mb-4" ref={card2Ref}>
            <Card
              className="text-white"
              style={{
                height: "60vh",
                border: "none",
                borderRadius: "20px",
                overflow: "hidden",
                position: "relative",
                cursor: "pointer",
              }}
            >
              {/* Image */}
              <img
                ref={cardimg2Ref}
                src={images.vh2}
                alt="Custom Made"
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  zIndex: 1,
                }}
              />

              {/* Content */}
              <Card.Body
                style={{
                  position: "relative",
                  zIndex: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "end",
                  borderRadius: "20px",
                  boxShadow: "rgba(0, 0, 0, 0.35) 0px -50px 36px 50px inset",
                }}
              >
                <Badge
                  style={{
                    backgroundColor: "rgba(128, 0, 128, 0.7)",
                    width: "fit-content",
                    padding: "2%",
                  }}
                  className="mb-2"
                >
                  CUSTOM MADE
                </Badge>
                <Card.Title
                  style={{ fontWeight: 700, fontSize: "1.5rem", color: "white" }}
                >
                  Exact Uniform <br /> Replication <br /> from Sample
                </Card.Title>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>

      {/* ========== 8 : Quate Section ========== */}
      <section section id="quate" ref={quateRef}>
        <div className="quate-section wrapper">
          <Container>
            <Row>
              <Col sm={12} className="text-center">
                <h2 ref={qoutetitleRef}>Get in Touch with Us</h2>
                <p>Let’s bring your corporate uniform vision to life. Whether it's for your entire workforce or a large team, we provide tailored solutions that meet your needs and reflect your brand.</p>
              </Col>
            </Row>
            <Row>
              <Col sm={12} className="text-center d-flex justify-content-center align-items-center">
                <Link to="/contact" style={{ textDecoration: 'none' }}>
                  <Button
                    type="button"
                    className="btn subscribe d-flex justify-content-center align-items-center"
                    ref={qoutebtnRef}
                  >
                    <span style={{ paddingRight: '5px', textDecoration: 'none' }}>Contact Us</span>
                    <i><FaArrowRight /></i>
                  </Button>
                </Link>
              </Col>
            </Row>
          </Container>
        </div>
      </section >

      {/* ========== 9 : Footer ========== */}


    </>
  );
};

export default Home;
